import { Radio } from "@mantine/core";
import { ConditionalType, SelectChoice } from "../../../helpers/types";
import FormInputField from "./FormInputField";

const RadioSelect = ({
   placeHolder,
   choices,
   isMulti,
   formData,
   options,
   ...rest
}: {
   name: string;
   label?: string;
   placeHolder?: string;
   choices: SelectChoice[];
   onChange: any;
   options?: {
      required?: boolean;
   };
   isMulti?: boolean;
   readOnly?: boolean;
   formData?: Map<string, any>;
   conditions?: ConditionalType[];
}) => {
   let curValue = formData?.get(rest.name)
   let fConditions = rest?.conditions?.filter((c) => c.allow(formData?.get(rest.name)))
   console.log({ curValue })
   return (
      <div className='flex-1 flex gap-4 flex-col'>
         <div><Radio.Group
            value={curValue}
            onChange={(value) => {
               rest.onChange({
                  currentTarget: {
                     name: rest.name,
                     value,
                  },
               });
            }
            }
            name={rest.name}
            label={`${rest.label}`}
            size="xs"
            withAsterisk
         >
            <div className="flex gap-2 items-center text-xs">{choices.map((o, idx) => (
               <Radio
                  key={idx}
                  value={o.value}
                  id={`${rest.name}-${idx}`}
                  label={o.label}
                  checked={formData?.get(rest.name) === o.value}
                  required={options?.required}
                  disabled={rest.readOnly && !(formData?.get(rest.name) === o.value)}
               />
            ))}</div>
         </Radio.Group></div>
         {fConditions && fConditions?.length > 0 && <div className='flex gap-1 flex-col bg-gray-100 p-1'>
            {fConditions.map((c, idx) => {
               return (
                  <div key={idx} className='text-xs flex-1 flex items-center'>
                     {c?.fields?.map((f) => <FormInputField  {...f} formData={formData} onChange={({ name, value }: any) => {
                        rest.onChange({ currentTarget: { name, value } })
                     }} />)}
                  </div>
               );
            })}
         </div>}
      </div>
   );
};

export default RadioSelect;
